import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { SalesBlock1 } from "./SalesBlock1";
import { SalesBlock2 } from "./SalesBlock2";
import { SalesBlock2_2 } from "./SalesBlock2_2";
import { SalesBlock3 } from "./SalesBlock3";
import { SalesBlock4 } from "./SalesBlock4";
import { SalesBlock4_2 } from "./SalesBlock4_2";
import { SalesBlock5 } from "./SalesBlock5";
import { SalesBlock5_2 } from "./SalesBlock5_2";
import { SalesBlock6 } from "./SalesBlock6";
import { SalesBlock7 } from "./SalesBlock7";
import { SalesBlock8 } from "./SalesBlock8";
import { SalesBlock9 } from "./SalesBlock9";
import { SalesBlock9_2 } from "./SalesBlock9_2";
import { SalesBlock10 } from "./SalesBlock10";
import { SalesBlock11 } from "./SalesBlock11";
import { SalesBlock12 } from "./SalesBlock12";

export const salesBlocks: BlockExportMapping = {
  SalesBlock1,
  SalesBlock2,
  SalesBlock2_2,
  SalesBlock3,
  SalesBlock4,
  SalesBlock4_2,
  SalesBlock5,
  SalesBlock5_2,
  SalesBlock6,
  SalesBlock7,
  SalesBlock8,
  SalesBlock9,
  SalesBlock9_2,
  SalesBlock10,
  SalesBlock11,
  SalesBlock12,
};
